<template>
  <div id="comp-match-manage">
    <transition name="modal">
      <div class="modal-mask">
        <div class="modal-wrapper">
          <div class="modal-container">
            <div class="modal-header">
              <slot name="header">
                {{ $t("matchManage.title") }}
              </slot>
            </div>
            <div class="modal-body">
              <slot name="body">
                <div
                  class="add-item"
                  @click="$emit('inviteFriend') && $emit('close')"
                >
                  <i class="fas fa-user-plus"></i>
                  <span>{{ $t("matchManage.inviteFriend") }}</span>
                </div>
                <div
                  class="add-item"
                  @click="$emit('makeGroup') && $emit('close')"
                >
                  <i class="fas fa-users"></i>
                  <span>{{ $t("matchManage.makeGroup") }}</span>
                </div>
              </slot>
            </div>
            <div class="modal-footer">
              <slot name="footer">
                <div class="btn-alone" @click="$emit('close')">
                  {{ $t("common.close") }}
                </div>
              </slot>
            </div>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  name: 'comp-match-manage',
};
</script>

<style lang="scss" src="../scss/comp-modal.scss" scoped></style>



// WEBPACK FOOTER //
// src/components/CompMatchManage.vue